import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    chartClicked: {
      type: Function,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, {
      onClick: (event, item) => {
        // emits event back to the parent with the clicked item index
        this.$emit("chartClicked", item[0]._index);
      },
      tooltipEvents: ["mousemove", "touchstart", "touchmove", "click"],
      tooltips: {
        enabled: false
      },
      legend: {
        display: false
      },
      responsive: true,
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false,
            drawBorder: false
          },
          ticks: {
            beginAtZero: true,
            max: 100,
            display: false
          }
        }],
        yAxes: [{
          stacked: true,
          gridLines: {
            display: false,
            drawBorder: false
          },
          barPercentage: 1.0,
          categoryPercentage: 0.9,
          ticks: {
            fontFamily: "museo-slab",
            fontColor: "#000000",
            fontStyle: 300,
            fontSize: 18,
            padding: -10,
            mirror: true
          }
        }]
      }
    });
  }
};
